import React from 'react';

const DraftColorPicker = (props)=> {

    const renderColorPickerIcon = ()=> {
        return (
        <svg  x="0px" y="0px" width="32px" height="16px"
        	 viewBox="-281 416.9 32 16">
        <g>
        	<rect x="-281" y="416.9" fill="#6A03B9" width="8" height="8"/>
        	<rect x="-273" y="416.9" fill="#9B37E7" width="8" height="8"/>
        	<rect x="-265" y="416.9" fill="#62A8FF" width="8" height="8"/>
        	<rect x="-257" y="416.9" fill="#8DCDFF" width="8" height="8"/>
        </g>
        <g>
        	<rect x="-281" y="424.9" fill="#00D0C8" width="8" height="8"/>
        	<rect x="-273" y="424.9" fill="#2FE4DD" width="8" height="8"/>
        	<rect x="-265" y="424.9" fill="#6BF9F4" width="8" height="8"/>
        	<rect x="-257" y="424.9" fill="#A5FFFC" width="8" height="8"/>
        </g>
        </svg>
        )
    }

    return (
    <div style={{display: "inline-block"}}>
        <div>{renderColorPickerIcon()}</div>
    </div>
    )
};

export default DraftColorPicker;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/DraftColorPicker.js